
import React from 'react';

interface NearbyMapProps {
  location: string;
  coordinates: {
    lat: number;
    lng: number;
  };
}

/**
 * Renders an embedded Google Map for the given location.
 * Includes basic validation and fallback UI to avoid rendering an invalid iframe.
 */
export const NearbyMap = ({ location, coordinates }: NearbyMapProps) => {
  // Guard against missing or malformed coordinates
  if (
    !coordinates ||
    typeof coordinates.lat !== 'number' ||
    typeof coordinates.lng !== 'number'
  ) {
    return (
      <div className="p-4 text-center text-gray-500">
        Invalid location data – map cannot be displayed.
      </div>
    );
  }

  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${coordinates.lat},${coordinates.lng}&zoom=14`;

  return (
    <div className="relative w-full h-96 bg-gray-100 rounded-lg overflow-hidden">
      <iframe
        src={mapUrl}
        className="w-full h-full border-0"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={`Map of ${location}`}
      />
    </div>
  );
};
